module.exports = "/_next/static/images/AIAndML-xs@2x-ca86e663b795c84038d585840aab3480.png";